<template>
  <hx-content-card class="related-child-item">
    <div class="childBody">
      <v-icon class="childIcon">mdi-file-table-outline</v-icon>
      <hx-tooltip
        id="tooltip-bottom"
        v-slot="props"
        :text="title"
        location="bottom"
        v-if="isTruncated"
      >
        <span class="bodyTitle" v-bind="props" ref="bodyTitle">
          {{ title }}
        </span>
      </hx-tooltip>

      <span v-else class="bodyTitle" ref="bodyTitle">
        {{ title }}
      </span>
    </div>
  </hx-content-card>
</template>

<script>
import { CSBase } from '@complispace/cs-design-system';

export default {
  name: 'RelatedPageCard',
  extends: CSBase,
  props: {
    title: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      isTruncated: false
    };
  },
  mounted() {
    this.checkTruncation();
  },
  methods: {
    checkTruncation() {
      const element = this.$refs.bodyTitle;
      if (element) {
        this.isTruncated = element.scrollHeight > element.offsetHeight;
      }
    }
  }
};
</script>

<style scoped>
.related-child-item {
  width: 327.38px;
  min-width: 272px;
  height: 78px;
}

.related-child-item .childBody {
  display: flex;
  align-items: center;
  height: 42px;
}

.related-child-item .childBody .childIcon {
  margin-right: 8px;
}

.related-child-item .childBody .bodyTitle {
  font-weight: 700;
  font-size: 14px;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: normal;
  letter-spacing: 0;
  line-height: 21px;
}
</style>
